module.exports = __webpack_public_path__ + "static/media/block-2-item-2.77e3a9e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/block-2-item-2.jpg
// module id = 1252
// module chunks = 270